const getters={
    currentRoute: state=>state.app.currentRoute,
    moduleIndex: state => state.app.moduleIndex,
    token: state => state.user.token,
    avatar: state => state.user.avatar,
    name: state => state.user.name,
    userInfo: state => state.user.userInfo,
    account: state => state.user.account,
    isAdmin: state => state.user.isAdmin,
}

export default getters;